import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const VERIFICATION_CODE_LENGTH = 7;

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

// Engage web app (e.g. https://engage.jobtetris.com). The Open Engage button is hidden when unset.
export const ENGAGE_APP_URL: string | undefined = import.meta.env.VITE_ENGAGE_APP_URL;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
